import { NavBarLink } from "Models/nav.bar.link";
import { Resources } from "Models/resources";

export const compareNavBarLink = (navBarLink: NavBarLink, resource: Resources) => {
  if (navBarLink?.resource) {
    return navBarLink.resource.toLocaleLowerCase() === resource.name.toLocaleLowerCase();
  }

  return navBarLink.path.includes(resource.name.toLowerCase());
};